<template>
  <ContactForm />
</template>

<script>
import ContactForm from './views/ContactForm.vue'

export default {
  name: "App",
  components: {
    ContactForm
  },
};
</script>

<style>
</style>
